import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { STATUSES } from "./leadUtils";

export const AdminFilters = ({ search, onSearch, statusFilter, onStatusFilter }) => (
  <div className="flex flex-col sm:flex-row gap-3 mb-6">
    <div className="relative flex-1">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500" />
      <Input
        data-testid="admin-search-input"
        className="bg-[#121212] border-zinc-800 text-white pl-10 h-11 rounded-sm placeholder:text-zinc-600"
        placeholder="Search name, phone, vehicle, service..."
        value={search}
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
    <Select value={statusFilter} onValueChange={onStatusFilter}>
      <SelectTrigger data-testid="admin-status-filter" className="bg-[#121212] border-zinc-800 text-white h-11 rounded-sm sm:w-52">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#1A1A1A] border-zinc-800 text-white">
        <SelectItem value="All" className="focus:bg-blue-600/20 focus:text-white">All Statuses</SelectItem>
        {STATUSES.map((s) => (
          <SelectItem key={s} value={s} className="focus:bg-blue-600/20 focus:text-white">{s}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
